import { FC } from 'react';
import { useParams } from 'react-router-dom';
import { api } from '@/redux/api';

export const ApiCheckPage: FC = () => {
  const { path } = useParams<{ path: string }>();
  const apiPath = `/${path}`;
  const state = api.endpoints.checkApi.useQuery({ path: apiPath });

  return (
    <div className="p-2">
      <p>
        <b>Request</b>
      </p>
      <p>
        <i>GET {apiPath}</i>
      </p>
      <p>
        <b>Error state</b>
      </p>
      <p>
        <i>{JSON.stringify(state.error, undefined, 2)}</i>
      </p>
      <p>
        <b>Query state</b>
      </p>
      <p>
        <i>{JSON.stringify(state, undefined, 2)}</i>
      </p>
    </div>
  );
};
